import React, { createContext, Reducer, useReducer } from 'react';

export type AuthRedirectState = {
	isAuthRedirect: boolean;
	redirectionComplete: boolean;
}

export type Actions = RedirectionComplete;

export type RedirectionComplete = {
	type: 'redirectionComplete';
}

const params = {
	code: new URLSearchParams(window.location.search).get('code') || '',
	state: new URLSearchParams(window.location.search).get('state') || ''
};
const Dispatch = createContext<React.Dispatch<Actions>>(() => {});
const State = createContext<AuthRedirectState>({
  isAuthRedirect: !!(params.code || params.state || false),
	redirectionComplete: false
});

const reducer: Reducer<AuthRedirectState, Actions> = (state, action) => {
	switch (action.type) {
		case 'redirectionComplete':
			return {
				...state,
				redirectionComplete: true
			};

		default:
			throw new Error('Invalid action type in AuthRedirect reducer');
	}
}

function Provider({ children }: { children: JSX.Element[] | JSX.Element }) {
	const [state, dispatch] = useReducer(reducer, {
		isAuthRedirect: !!(params.code || params.state || false),
		redirectionComplete: false
	});

	// The state and the dispatch function should be provided separately so that components that are interested
	// only in dispatching events don't need to use the state and thus re-render when the state changes
	// See here - https://reactjs.org/docs/hooks-faq.html#how-to-avoid-passing-callbacks-down
	return (
		<State.Provider value={state}>
			<Dispatch.Provider value={dispatch}>{children}</Dispatch.Provider>
		</State.Provider>
	)
}

export const AuthRedirect = {
	State,
	Dispatch,
	Provider
};